import React from "react";

// ASSETS
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";

// STYLES
import {
  DescriptionWrapper,
  PartnerDetailsContainer,
  PartnerDetailsIcon,
  PartnerDetailsIconContainer,
  PartnerDetailsIconTitle,
  PartnerDetailsIconWrapper,
  PartnerDetailsTextContainer,
} from "./PartnerDetailsStyled";

// LIBRARIES

// MISC
import { IProps } from "./PartnerDetailsModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import { uploadBaseUrl } from "services/base";

import StrapiTreeText from "components/Atoms/StrapiTreeText/StrapiTreeText";

const PartnerDetails = (props: IProps) => {
  // PROPERTIES
  const { item } = props;
  // LIBRARY CONSTANTS

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <PartnerDetailsContainer>
      <PartnerDetailsIconContainer>
        <PartnerDetailsIconWrapper>
          <PartnerDetailsIcon
            src={
              item?.attributes?.logo?.data?.attributes?.url?.trim()
                ? `${uploadBaseUrl}${item?.attributes?.logo?.data?.attributes?.url}`
                : CoverPlaceholder
            }
          />
        </PartnerDetailsIconWrapper>
        <PartnerDetailsIconTitle>
          <CustomText
            text={item?.attributes?.title}
            type={TextType.H3}
            color={COLORS.Yellow}
          />
        </PartnerDetailsIconTitle>
      </PartnerDetailsIconContainer>
      <PartnerDetailsTextContainer>
        <DescriptionWrapper>
        <StrapiTreeText
          text={item?.attributes?.content  || [[
            {
                "type": "paragraph",
                "children": [
                    {
                        "text": "N/A",
                        "type": "text"
                    }
                ]
            }
        ]]}
          
          color={COLORS.Background}
        />
        </DescriptionWrapper>
       
      </PartnerDetailsTextContainer>
    </PartnerDetailsContainer>
  );
};

export default PartnerDetails;
